//
// Utilities
//
// Dependencies
import * as registry from '@core/registry';

//
// Constants
export const MODULE_NAME = registry.LOCATOR_MODULE;
export const MODULE_SELECTOR = '[data-locator]';
export const ASSETS = [
	'../scripts/seeu2-locator.module.js',
	'../styles/seeu2-locator.module.css',
];

//
// Load
export default function load() {
	registry.dynamicLoader(MODULE_NAME, MODULE_SELECTOR, ASSETS);
}



// WEBPACK FOOTER //
// ./project/client/src/site__seeu2/modules/locator/dynamic-load.js